import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const searchExplorerPlugin = createPlugin({
  id: 'search-explorer',
  routes: {
    root: rootRouteRef,
  },
});

export const SearchExplorerPage = searchExplorerPlugin.provide(
  createRoutableExtension({
    name: 'SearchExplorerPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
